<template>
  <div class="after_sales_detail">
    <div class="after_sales_detail_content">
      <!--售后单详情头部-->
      <div v-if="salesAfterMsg" class="after_sales_detail_top mt10">
        <!--<button class="btn_normal mt10 ml10">返回售后列表</button>-->
        <a class="ml10" title="返回" @click="$router.go(-1)"><i class="iconfont icon-return"></i>返回</a>
        <button class="btn_normal mt10 ml10" @click="ctrlBtn('log', salesAfterMsg)">日志</button>
        <button v-if="salesAfterMsg.ReStatusName === '待受理'" class="btn_normal mt10 ml10" title="受理" @click="ctrlBtn('toAccept', salesAfterMsg)">受理</button>
        <button v-if="salesAfterMsg.ReStatusName === '待收货' && salesAfterMsg.BackStoreroomName !== '自收'" class="btn_normal mt10 ml10" title="撤回" @click="ctrlBtn('pullBack', salesAfterMsg)">撤回</button>
        <button v-if="salesAfterMsg.ReStatusName === '待受理' || salesAfterMsg.ReStatusName === '待退货' || salesAfterMsg.ReStatusName === '拒绝售后'" class="btn_normal mt10 ml10" @click="ctrlBtn('modifySalesDetail', salesAfterMsg)" title="修改明细">修改明细</button>
        <button v-if="salesAfterMsg.ReStatusName === '待受理' || salesAfterMsg.ReStatusName === '待退货' || salesAfterMsg.ReStatusName === '拒绝售后'" class="btn_normal mt10 ml10" @click="ctrlBtn('closeSalesAfter', salesAfterMsg)" title="终止售后">终止售后</button>
        <button v-if="salesAfterMsg.ReStatusName === '待退货'" class="btn_normal mt10 ml10" title="退回物流" @click="ctrlBtn('returnLogistic', salesAfterMsg)">退回物流</button>
        <button v-if="salesAfterMsg.ReStatusName === '待收货' && salesAfterMsg.BackStoreroomName === '自收'" class="btn_normal mt10 ml10">确认收货</button>
        <button v-if="salesAfterMsg.ReStatusName === '拒绝售后'" class="btn_normal mt10 ml10">重新提交</button>
      </div>

      <!--售后单详情内容-->
      <div v-if="salesAfterMsg" class="after_sales_detail_msg ml5 mr5">
        <p class="text_center mt20 mb10">售后单详情</p>
        <table class="table tb_border">
          <tr>
            <td class="text_right">售后单号：</td>
            <td class="text_left">
              <p class="no_newline">内：{{salesAfterMsg.RefundId}}</p>
              <p>外：{{salesAfterMsg.OutRefundId}}</p>
            </td>
            <td class="text_right">订单号：</td>
            <td class="text_left no_newline">
              <a  title="订单详情" @click="ctrlBtn('orderDetail', salesAfterMsg)">{{salesAfterMsg.OrderId}}({{salesAfterMsg.OrderSysStatusName}})</a>
            </td>
            <td class="text_right">售后类型：</td>
            <td class="text_left no_newline">{{salesAfterMsg.ReTypeName}}</td>
            <td class="text_right">售后状态：</td>
            <td class="text_left no_newline">{{salesAfterMsg.ReStatusName}}</td>
          </tr>
          <tr>
            <td class="text_right">原因：</td>
            <td class="text_left">{{salesAfterMsg.RefundReasonName}}</td>
            <td class="text_right">订单发出渠道：</td>
            <td class="text_left no_newline">
              {{salesAfterMsg.SendOutStoreroomName}}
              <a v-if="salesAfterMsg.SendOutStoreroomQQ" :href="'tencent://message/?uin=' + salesAfterMsg.SendOutStoreroomQQ + '&Menu=yes&Service=300&sigT=42a1e5347953b64c5ff3980f8a6e644d4b31456cb0b6ac6b27663a3c4dd0f4aa14a543b1716f9d45'">
                <img src="../../../assets/img/qq.gif" height="17" width="25"/>
              </a>
            </td>
            <td class="text_right">受理退货渠道：</td>
            <td class="text_left no_newline">
              {{salesAfterMsg.BackStoreroomName}}
              <a v-if="salesAfterMsg.BackStoreroomQQ" :href="'tencent://message/?uin=' + salesAfterMsg.BackStoreroomQQ + '&Menu=yes&Service=300&sigT=42a1e5347953b64c5ff3980f8a6e644d4b31456cb0b6ac6b27663a3c4dd0f4aa14a543b1716f9d45'">
                <img src="../../../assets/img/qq.gif" height="17" width="25"/>
              </a>
            </td>
            <td class="text_right">退回物流：</td>
            <td class="text_left no_newline">
            <span class="inb" v-if="salesAfterMsg.LogisticName">
            <!--<span>-->
            {{salesAfterMsg.LogisticName}}：
            </span>
              <a title="快递单号" @click="ctrlBtn('logisticNumDetail', salesAfterMsg)">{{salesAfterMsg.ExpressNum}}</a>
              <i class="iconfont icon-modify" @click="ctrlBtn('modifyReturnLogistic', salesAfterMsg)"></i>
            </td>
          </tr>
          <tr>
            <td class="text_right">退回收货信息：</td>
            <td class="text_left" colspan="5">{{salesAfterMsg.BackStoreroomInfo}}</td>
            <td class="text_right">买家退款金额(元)：</td>
            <td class="text_left no_newline">{{salesAfterMsg.TuiMoney}}<i class="fcDel">({{salesAfterMsg.RefundMoney}})</i></td>
          </tr>
          <tr>
            <td class="text_right">结算状态：</td>
            <td class="text_left">{{salesAfterMsg.SettleStatusName}}</td>
            <td class="text_right">平台应退货款(元)：</td>
            <!--<td class="text_left no_newline">450.22<i class="fcDel">(不包含已付运费12.00元)</i></td>-->
            <td class="text_left no_newline">{{salesAfterMsg.TotalAgentCostPrice}}<i class="fcDel">(不包含已付运费{{salesAfterMsg.CourierFee}}元)</i></td>
            <td class="text_right">额外退费金额：</td>
            <td class="text_left no_newline">{{salesAfterMsg.PXExtMoney}}</td>
            <!--<td class="text_left no_newline">{{salesAfterMsg.PXExtMoney}}<i class="iconfont icon-modify" @click="ctrlBtn('extraRefund', salesAfterMsg)"></i></td>-->
            <td class="text_right">渠道调整金额：</td>
            <td class="text_left no_newline">{{salesAfterMsg.SPExtMoney}}</td>
          </tr>
          <tr>
            <td class="text_right">申请时间：</td>
            <td class="text_left">{{salesAfterMsg.CreateTime | time}}</td>
            <td class="text_right">申请人：</td>
            <td class="text_left no_newline">{{salesAfterMsg.CreaterName}}</td>
            <td class="text_right">受理人：</td>
            <td class="text_left no_newline">{{salesAfterMsg.CheckerName}}</td>
            <td class="text_right">完成时间：</td>
            <td class="text_left no_newline">{{salesAfterMsg.RefundSuccessTime | time}}</td>
          </tr>
          <tr>
            <td class="text_right">买家留言：</td>
            <td class="text_left" colspan="3">{{salesAfterMsg.RefundDesc }}</td>
            <td class="text_right">内部备注：</td>
            <td class="text_left" colspan="3">{{salesAfterMsg.AgentRemark}}<i class="iconfont icon-modify" @click="ctrlBtn('modifyRemark', salesAfterMsg)"></i></td>
          </tr>
          <tr>
            <td class="text_left fcBlue" colspan="8">温馨提示：对符合平台退款的售后单，平台默认不退运费，分销商可根据与渠道协商情况设定额外退费金额，最终退款结算金额的计算为【平台应退货款】+【额外退费金额】+【渠道调整金额】。</td>
          </tr>
        </table>

        <div>
          <p class="text_center mt20 mb10">售后货品明细</p>
          <table class="table tb_border">
            <thead>
            <tr>
              <th>品名</th>
              <th>货号</th>
              <th>尺码</th>
              <th>数量</th>
              <th>市场价</th>
              <th>成交单价</th>
              <th>优惠金额</th>
              <th>合计</th>
              <th>拿货单价</th>
              <th>拿货单价合计</th>
              <th>错发货号</th>
              <th>错发尺码</th>
              <th>错发？</th>
            </tr>
            <tr v-for="(item, index) in salesAfterMsg.RefundDetailList" :key="index">
              <td>{{item.GoodsName}}</td>
              <td>{{item.GoodsId}}</td>
              <td>{{item.SizeName}}</td>
              <td>{{item.Quantity}}</td>
              <td>{{item.MarketPrice}}</td>
              <td>{{item.UnitPrice}}</td>
              <td>{{item.OfferFee}}</td>
              <td>{{item.clinchADealUnitpriceRow}}</td>
              <td>{{item.AgentCostPrice}}</td>
              <td>{{item.takeAUnitPriceOfGoodsRow}}</td>
              <td>{{item.WrongSendGoodsId}}</td>
              <td>{{item.WrongSendSize}}</td>
              <td v-if="item.WrongSendSkuId">是</td>
              <td v-if="!item.WrongSendSkuId">否</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="no_newline">合计：</td>
              <td>{{salesAfterMsg.totalQuantity}}</td>
              <td></td>
              <td></td>
              <td class="no_newline">合计：</td>
              <td>{{salesAfterMsg.clinchADealUnitpriceCol}}</td>
              <td class="no_newline">合计：</td>
              <td>{{salesAfterMsg.takeAUnitPriceOfGoodsCol}}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </thead>
          </table>
        </div>

        <div class="mb30">
          <div class="inb w_percent65">
            <p class="text_center mt20 mb10">留言列表</p>
            <table class="table tb_border">
              <thead>
              <tr>
                <th>留言方</th>
                <th>操作人</th>
                <th>内容</th>
                <th>留言时间</th>
              </tr>
              </thead>
              <tbody v-if="salesAfterMsg.RefundMessageList.length">
              <tr v-for="(item, index) in salesAfterMsg.RefundMessageList" :key="index">
                <td>{{item.SourceName}}</td>
                <td>{{item.CreaterName}}</td>
                <td style="max-width: 310px">{{item.Remark}}</td>
                <td>{{item.CreateTime | time}}</td>
              </tr>
              </tbody>
              <tbody v-if="!salesAfterMsg.RefundMessageList.length">
              <tr>
                <td colspan="4">暂时没有相关的留言</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="inb w_percent30 fr text_center">
            <p class="text_center mt20 mb10">留言</p>
            <textarea class="w_percent92 h100" maxlength="200" placeholder="输入框限制最多只能输入200个字符" v-model.trim="salesRemark"></textarea>
            <div><button class="btn_normal mt10 mb30" @click="saveRefundMessage()">保存</button></div>
          </div>
        </div>
      </div>
    </div>

    <!--弹出框-->
    <after-sales-embed-msg v-if="isShow && dialogShowType !== 'orderDetail'"
                           :title="dialogTitle"
                           :msg="orderMsg"
                           :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></after-sales-embed-msg>

    <!--弹出框---订单详情  -->
    <order-list-embed-msg v-if="isShow && dialogShowType === 'orderDetail'"
                          :title="dialogTitle"
                          :showType="dialogShowType"
                          :orderMsg="orderMsg"
                          @cancelbtn="getSelectDialogEmbed"></order-list-embed-msg>
    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import AfterSalesEmbedMsg from './after-sales-embed-msg';
  import OrderListEmbedMsg from './order-list-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'after-sales-detail',
    components: {AfterSalesEmbedMsg, OrderListEmbedMsg, LoadingDialog, MsgDialog},
    data() {
      return {
        orderMsg: null, // 订单信息
        salesAfterMsg: null, // 售后信息
        salesRemark: null, // 售后留言
        scrollLeft: 0, // 滚动宽度
        scrollHeight: 0, // 滚动高度
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null // 弹出框类型
      }
    },
    methods: {
      // 根据售后单号获取售后单详情（包含售后主单、售后明细、售后留言）
      getRefundDataByRefundId(salesAfterId) {
        this.$axios.post(this.Global.getRefundDataByRefundId(salesAfterId), null).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.salesAfterMsg = res.data.resData;
                // self.list = res.data.resData.DataList;
                // self.total = res.data.resData.TotalCounts;
                // RefundDetailList
                self.$set(self.salesAfterMsg, 'totalQuantity', 0);
                self.$set(self.salesAfterMsg, 'clinchADealUnitpriceCol', 0);
                self.$set(self.salesAfterMsg, 'takeAUnitPriceOfGoodsCol', 0);
                let totalQuantity = 0;
                let clinchADealUnitpriceCol = 0;
                let takeAUnitPriceOfGoodsCol = 0;
                for (let i = 0; i < self.salesAfterMsg.RefundDetailList.length; i++) {
                  self.$set(self.salesAfterMsg.RefundDetailList[i], 'clinchADealUnitpriceRow', 0);
                  self.$set(self.salesAfterMsg.RefundDetailList[i], 'takeAUnitPriceOfGoodsRow', 0);
                  totalQuantity = totalQuantity + self.salesAfterMsg.RefundDetailList[i].Quantity;
                  self.salesAfterMsg.RefundDetailList[i].clinchADealUnitpriceRow = self.Global.subtraction(self.Global.multiplication(self.salesAfterMsg.RefundDetailList[i].Quantity, self.salesAfterMsg.RefundDetailList[i].UnitPrice), self.salesAfterMsg.RefundDetailList[i].OfferFee);
                  self.salesAfterMsg.RefundDetailList[i].takeAUnitPriceOfGoodsRow = self.Global.multiplication(self.salesAfterMsg.RefundDetailList[i].Quantity, self.salesAfterMsg.RefundDetailList[i].AgentCostPrice);
                  clinchADealUnitpriceCol = self.Global.addition(clinchADealUnitpriceCol, self.salesAfterMsg.RefundDetailList[i].clinchADealUnitpriceRow);
                  takeAUnitPriceOfGoodsCol = self.Global.addition(takeAUnitPriceOfGoodsCol, self.salesAfterMsg.RefundDetailList[i].takeAUnitPriceOfGoodsRow);
                }
                self.salesAfterMsg.totalQuantity = totalQuantity;
                self.salesAfterMsg.clinchADealUnitpriceCol = clinchADealUnitpriceCol;
                self.salesAfterMsg.takeAUnitPriceOfGoodsCol = takeAUnitPriceOfGoodsCol;
              } else {
                // self.list = [];
                // self.listErr = res.data.errorMsg;
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 提交售后留言
      saveRefundMessage() {
        if (!this.salesRemark) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入留言';
          return;
        }
        this.$axios.post(this.Global.saveRefundMessage(this.salesAfterMsg.RefundId, this.salesRemark), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功';
            this.getRefundDataByRefundId(this.$route.query['salesAfterId']);
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.dialogShowType = type;
        this.orderMsg = msg;
        switch (type) {
          case 'orderDetail':
            this.dialogTitle = '订单详情';
            break;
          case 'modifyReturnLogistic':
            this.dialogTitle = '编辑退回物流信息';
            break;
          case 'returnLogistic':
            this.dialogTitle = '退回物流';
            break;
          case 'extraRefund':
            this.dialogTitle = '编辑额外退费金额';
            break;
          case 'modifyRemark':
            this.dialogTitle = '编辑备注';
            break;
          case 'toAccept':
            this.dialogTitle = '售后受理';
            break;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.getRefundDataByRefundId(this.$route.query['salesAfterId']);
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
       /* if (!e.isSuc) {
          window.history.back(-1);
        } */
      }
    },
    created() {
      if (this.$route.query['salesAfterId']) {
        this.getRefundDataByRefundId(this.$route.query['salesAfterId']);
      }
    },
    activated() {
      if (this.$route.query['salesAfterId']) {
        this.getRefundDataByRefundId(this.$route.query['salesAfterId']);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .after_sales_detail {
    /*overflow: hidden;*/
    width: 100%;
    height: 100%;
    position: relative;

    .after_sales_detail_content {
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/after-sales-detail.vue